const config = {
    WS_BASE_URL: 'https://pdf-text-replacer.avia-office.com/api/',
    SOCKET_BASE_URL: 'https://pdf-text-replacer.avia-office.com',
    DOMAIN_NAME: 'https://pdf-text-replacer.avia-office.com',
    // WS_BASE_URL: 'http://localhost:5100/api/',
    // SOCKET_BASE_URL: 'http://localhost:5100',
    // DOMAIN_NAME: 'http://localhost:3000',
    DEMO: true
}

export default config;
